import React, { useState, useEffect } from "react";
import { GoldenSourceHelper } from "../../../../app/Switch_Core_React_Standards";
import SEC_03_UserMatrixView from "./SEC_03_UserMatrixView"; 

export default function SEC_03_UserMatrixController({ targetUserGuid }) {
  const [matrixData, setMatrixData] = useState([]);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [availableDivisions, setAvailableDivisions] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🎯 RESTORED: Metadata handshake for Add Assignment dropdowns
  const executeHandshake = async (slug, payload) => {
    const token = sessionStorage.getItem("SEC_SESSION_ID");
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/${slug}`, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "SITE-KEY": process.env.REACT_APP_SITE_KEY,
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(payload || {})
    });
    const result = await response.json();
    return GoldenSourceHelper.normalize(result);
  };

  useEffect(() => {
    const loadAllData = async () => {
      if (!targetUserGuid) return;
      setLoading(true);
      try {
        // Parallel load of Matrix and Metadata
        const [m, r, d] = await Promise.all([
          executeHandshake("sustina/manage-users/matrix", { TargetUserGuid: targetUserGuid }),
          executeHandshake("sustina/manage-users/roles", {}),
          executeHandshake("sustina/manage-users/resources", { ResourceType: "Division" })
        ]);

        setMatrixData(m.data || []);
        setAvailableRoles(r.data || []);
        setAvailableDivisions(d.data || []);
      } catch (err) {
        console.error("Matrix or Metadata load failed", err);
      } finally {
        setLoading(false);
      }
    };
    loadAllData();
  }, [targetUserGuid]);

  return (
    <SEC_03_UserMatrixView 
      data={matrixData} 
      loading={loading} 
      availableRoles={availableRoles} 
      availableDivisions={availableDivisions} 
    />
  );
}